function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Panel from '@/components/Panel';
import { FormattedMessage, useIntl } from 'react-intl';
import Table from '../Table';
import { ActionIcon, Loader, Table as MantineTable, Title } from '@mantine/core';
import Icon, { IconSizes } from '../Icon';
import styles from './TopCommand.module.scss';
import TableHeading from '../TableHeading';
var MAX_COMMANDS = 5;
export default function TopCommand(param) {
    var commandStats = param.commandStats, isLoading = param.isLoading;
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(0), 2), page = _React_useState[0], setPage = _React_useState[1];
    var commands = React.useMemo(function() {
        var offset = page * MAX_COMMANDS;
        var _commandStats_commands_slice;
        var commands = (_commandStats_commands_slice = commandStats === null || commandStats === void 0 ? void 0 : commandStats.commands.slice(offset, offset + MAX_COMMANDS)) !== null && _commandStats_commands_slice !== void 0 ? _commandStats_commands_slice : [];
        while(commands.length < MAX_COMMANDS){
            commands.push(null);
        }
        return commands;
    }, [
        commandStats === null || commandStats === void 0 ? void 0 : commandStats.commands,
        page
    ]);
    if (isLoading) {
        return /*#__PURE__*/ _jsx(Panel, {
            display: "grid",
            placeItems: "center",
            height: "100%",
            children: /*#__PURE__*/ _jsx(Loader, {})
        });
    }
    if (commands.length === 0) {
        return /*#__PURE__*/ _jsx(Panel, {
            display: "grid",
            placeItems: "center",
            height: "100%",
            children: /*#__PURE__*/ _jsx(Title, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "RxjQku",
                    defaultMessage: "No Commands"
                })
            })
        });
    }
    var hasMore = commandStats != null ? commandStats.commands.length > (page + 1) * MAX_COMMANDS : false;
    return /*#__PURE__*/ _jsx(Table, {
        data: commands,
        extraData: [
            page,
            hasMore
        ],
        keyExtractor: function(command, index) {
            return command == null ? "empty-".concat(index) : command.name;
        },
        renderRow: function(command, index) {
            return command == null ? /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                children: [
                    /*#__PURE__*/ _jsx(MantineTable.Td, {
                        className: styles.hidden,
                        children: "-"
                    }),
                    /*#__PURE__*/ _jsx(MantineTable.Td, {
                        className: styles.hidden,
                        children: "-"
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                children: [
                    /*#__PURE__*/ _jsx(MantineTable.Td, {
                        children: command.name
                    }),
                    /*#__PURE__*/ _jsx(MantineTable.Td, {
                        children: command.lines
                    })
                ]
            });
        },
        renderHeader: function() {
            return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                children: [
                    /*#__PURE__*/ _jsx(TableHeading, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "NS7TSL",
                            defaultMessage: "Top Commands"
                        })
                    }),
                    /*#__PURE__*/ _jsx(TableHeading, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "Vb+qQ4",
                            defaultMessage: "Uses"
                        })
                    })
                ]
            });
        },
        renderFooter: function() {
            return /*#__PURE__*/ _jsxs("div", {
                className: styles.pagination,
                children: [
                    /*#__PURE__*/ _jsx(ActionIcon, {
                        size: "xs",
                        "aria-label": intl.formatMessage({
                            id: "6TbqAD",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Previous Page"
                                }
                            ]
                        }),
                        disabled: page === 0,
                        onClick: function() {
                            return setPage(page - 1);
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            size: IconSizes.SM,
                            icon: faChevronLeft
                        })
                    }),
                    /*#__PURE__*/ _jsx(ActionIcon, {
                        size: "xs",
                        "aria-label": intl.formatMessage({
                            id: "uuLnK5",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Next Page"
                                }
                            ]
                        }),
                        disabled: !hasMore,
                        onClick: function() {
                            return setPage(page + 1);
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            size: IconSizes.SM,
                            icon: faChevronRight
                        })
                    })
                ]
            });
        }
    });
}
